import { render, staticRenderFns } from "./current.vue?vue&type=template&id=45f2f3c3&scoped=true"
import script from "./current.vue?vue&type=script&lang=js"
export * from "./current.vue?vue&type=script&lang=js"
import style0 from "./current.vue?vue&type=style&index=0&id=45f2f3c3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f2f3c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f2f3c3')) {
      api.createRecord('45f2f3c3', component.options)
    } else {
      api.reload('45f2f3c3', component.options)
    }
    module.hot.accept("./current.vue?vue&type=template&id=45f2f3c3&scoped=true", function () {
      api.rerender('45f2f3c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assessment/components/current.vue"
export default component.exports